import { LegalDoc } from '../legal-doc.model';

/** French version — mirrors chroniq-privacy.de.ts section for section. */
export const CHRONIQ_PRIVACY_FR: LegalDoc = {
    title: 'Déclaration de protection des données Chroniq',
    meta: 'État au 3 novembre 2026 · Valable pour l\'application Chroniq (iOS, web) et chroniq.ch',
    tocHeading: 'Sommaire',
    footer: 'La version allemande fait foi. Les traductions servent à la compréhension.',
    sections: [
        {
            num: '01',
            title: 'Répartition des rôles : responsable du traitement et sous-traitant',
            body: `
        <p>Chroniq est une solution logicielle en tant que service multi-locataires mise à la disposition
        des établissements (le « client » ou l'« employeur ») pour la saisie du temps de travail et la
        gestion du personnel.</p>
        <p>Lors du traitement des données des collaborateurs — saisie du temps, planification des services,
        absences, messagerie, profil — <strong>c'est l'employeur concerné qui est le responsable du
        traitement</strong> au sens de la loi fédérale suisse sur la protection des données (LPD) et, dans
        la mesure où il s'applique, du règlement général sur la protection des données (RGPD). La
        <strong>Gastro Management Oberbillig</strong> (« l'exploitante », « nous ») agit à cet égard
        comme <strong>sous-traitante</strong> au sens de l'art. 9 LPD et de l'art. 28 RGPD, sur la base d'un
        contrat de sous-traitance conclu avec chaque client.</p>
        <p><strong>Nous sommes nous-mêmes responsables</strong> de l'exploitation, de la sécurité et du
        développement de la plateforme, y compris des données techniques de diagnostic (ch. 09), de la
        gestion de la relation client ainsi que de notre site web.</p>
        <p>La présente déclaration informe de manière complète sur les traitements effectués au sein de
        Chroniq. Les employeurs peuvent également s'en servir pour remplir leur propre devoir d'information
        envers les collaborateurs (art. 328b CO, art. 19 LPD, art. 13 s. RGPD). Les collaborateurs
        adressent leurs questions relatives à un traitement concret d'abord à leur employeur ; nous restons
        également à disposition pour les questions relatives à la plateforme :</p>
        <p><strong>Gastro Management Oberbillig</strong><br>
        Entreprise individuelle, titulaire : Erik Alexander Oberbillig<br>
        Exploitante de l'application Chroniq<br>
        Kirchenrütti 14, 6463 Bürglen UR, Suisse</p>
        <p>Protection des données Chroniq : <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a><br>
        Service central de protection des données du groupe : <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
      `,
        },
        {
            num: '02',
            title: 'Données de connexion',
            body: `
        <p>L'authentification s'effectue via <strong>Auth0</strong> sur un locataire européen
        (<code>*.eu.auth0.com</code>) avec conservation des données dans l'UE. Le fournisseur est
        Okta, Inc. Sont traitées :</p>
        <ul>
          <li>l'adresse électronique</li>
          <li>le nom et le prénom</li>
          <li>la photo de profil (facultative, issue du jeton d'authentification)</li>
          <li>l'identifiant d'utilisateur (Auth0 Subject Identifier)</li>
          <li>le rôle d'accès (<em>employee</em>, <em>chef</em>, <em>admin</em>)</li>
          <li>l'état d'intégration</li>
        </ul>
        <p>Auth0 intervient comme sous-traitant ; un contrat de sous-traitance est conclu avec Okta, Inc.
        La société mère étant soumise au droit des États-Unis et un accès depuis les États-Unis dans le
        cadre du support et de la maintenance ne pouvant être entièrement exclu, cet éventuel élément
        d'extranéité est couvert par les clauses contractuelles types de l'UE (ch. 13).</p>
        <p><strong>Nous n'enregistrons aucun mot de passe.</strong></p>
      `,
        },
        {
            num: '03',
            title: 'Données de saisie du temps de travail',
            body: `
        <p>L'application enregistre :</p>
        <ul>
          <li>le début, la fin et la date des périodes de travail</li>
          <li>les pauses (début, fin, durée)</li>
          <li>l'état du travail (en cours, en pause, terminé)</li>
          <li>des remarques facultatives relatives à la période</li>
          <li>les indicateurs journaliers et hebdomadaires ainsi que le solde d'heures supplémentaires</li>
        </ul>
        <p>Cela comprend les corrections de temps et saisies a posteriori, avec leur motif et la décision du
        responsable, ainsi que la clôture mensuelle. Un <strong>journal des modifications</strong> consigne, pour
        les modifications apportées aux données du personnel et de temps, qui a modifié quoi et quand
        (identifiant et rôle de la personne agissante, moment, enregistrement concerné, champs modifiés). Les
        champs sensibles tels que le numéro AVS ou l'IBAN n'y figurent pas en clair. Le journal sert à la
        traçabilité à l'égard de l'employeur et à la sécurité ; il n'est pas exploité pour contrôler le
        comportement ou les performances (ch. 19).</p>
        <p>Ce traitement sert à remplir l'obligation d'enregistrement de l'employeur selon l'art. 46 de la
        loi sur le travail et l'art. 73 de l'ordonnance 1 relative à la loi sur le travail, ainsi qu'au
        décompte correct du salaire.</p>
        <p><strong>Aucune géolocalisation :</strong> Chroniq ne collecte <strong>aucune</strong> donnée de
        localisation ou de position de l'appareil lors du pointage et n'exploite aucun profil de
        déplacement.</p>
      `,
        },
        {
            num: '04',
            title: 'Saisie du temps par terminaux de badge',
            body: `
        <p>Lorsqu'un employeur utilise des terminaux de badge RFID physiques, les événements de lecture
        (identifiant du badge, identifiant de l'appareil, horodatage) sont traités via Microsoft Azure IoT
        Hub, attribués à un collaborateur et repris comme pointage d'entrée ou de sortie ; un bref accusé
        de réception est renvoyé au terminal. Les pauses peuvent aussi être scannées au terminal (pause, fin de pause).</p>
        <p>L'identifiant du badge est un simple numéro de carte et ne contient aucune caractéristique
        biométrique.</p>
        <p>Après la lecture, le terminal affiche brièvement le nom, le résultat et, sauf si
        l'établissement l'a désactivé, le total du jour (« Travaillé aujourd'hui » et « Pauses »). Pour que le
        terminal fonctionne aussi sans connexion réseau, il enregistre localement, sous forme chiffrée, les
        noms des titulaires de badge et les lectures pas encore envoyées. L'exploitant peut accéder à
        distance à l'appareil à des fins de maintenance. La conservation des données de saisie du temps est
        régie par le ch. 11.</p>
        <p>Au lieu d'une carte physique, un badge numérique dans Apple Wallet peut également être utilisé
        (ch. 08).</p>
        <p><em>Cette fonction est en phase pilote</em> et n'est activée que chez certains établissements
        qui utilisent expressément le terminal passerelle.</p>
      `,
        },
        {
            num: '05',
            title: 'Planification des services et absences',
            body: `
        <p>Les responsables créent les services et statuent sur les demandes d'absence. Sont traités :</p>
        <ul>
          <li>les horaires et modèles de service ainsi que les exports d'agenda (iCal)</li>
          <li>le type d'absence (<em>vacances</em>, <em>maladie</em>, <em>accident</em>,
              <em>maternité/paternité</em>, <em>service militaire</em>, <em>formation</em>,
              <em>jour de compensation</em>, <em>autre</em>) en tant que simple catégorie, sans champ de
              diagnostic ni de certificat, ainsi que la période, le statut et le compte de vacances</li>
          <li>les demandes d'échange de service entre collaborateurs et la décision du responsable</li>
          <li>les champs de texte libre « remarque » et « motif de refus »</li>
        </ul>
        <p><strong>Remarque sur la minimisation des données :</strong> les catégories « maladie », « accident » et « maternité/paternité »
        n'enregistrent techniquement aucun diagnostic. Les champs de texte libre sont toutefois du texte
        brut non vérifié. Les collaborateurs et les responsables sont priés de n'y inscrire aucune
        indication de santé ni aucune autre donnée sensible (art. 5 let. c LPD / art. 9 RGPD), sauf
        nécessité expresse. Si de telles données y sont néanmoins saisies, nous les traitons pour le compte
        de l'employeur avec les mêmes restrictions d'accès que les autres données du personnel.</p>
      `,
        },
        {
            num: '06',
            title: 'Données et profil des collaborateurs',
            body: `
        <p>Le système gère les données de personnel suivantes :</p>
        <ul>
          <li>nom, adresse électronique, numéro de téléphone</li>
          <li>numéro de personnel, fonction, département, date d'entrée</li>
          <li>état de l'invitation (en attente, acceptée, révoquée)</li>
          <li>photo de profil facultative dans un conteneur de stockage privé, accessible uniquement par
              des adresses signées à durée limitée</li>
        </ul>
        <p>Seules les personnes ayant le rôle <em>chef</em> ou <em>admin</em> peuvent en outre traiter :</p>
        <ul>
          <li>le numéro AVS</li>
          <li>l'IBAN ou les coordonnées bancaires</li>
          <li>la date de naissance</li>
          <li>l'adresse du domicile</li>
          <li>le contact d'urgence (nom, lien, numéro de téléphone)</li>
        </ul>
        <p>Selon l'art. 328b CO, l'employeur ne peut traiter que les données qui portent sur les aptitudes
        du travailleur à remplir son emploi ou qui sont nécessaires à l'exécution du contrat de travail.
        Il incombe à l'employeur de ne renseigner que de tels champs.</p>
      `,
        },
        {
            num: '07',
            title: 'Messagerie d\'équipe et annonces',
            body: `
        <p>Lorsque la fonction de messagerie est activée, sont traités :</p>
        <ul>
          <li>le contenu du message, l'expéditeur, l'horodatage ainsi que l'état de modification et de
              suppression. Les messages supprimés disparaissent de l'affichage ; leur contenu subsiste
              techniquement dans la base (suppression logique) et est définitivement effacé lors de
              l'anonymisation du compte ou sur instruction de l'employeur.</li>
          <li>les accusés de lecture par utilisateur et par message</li>
          <li>les pièces jointes (PDF, JPEG, PNG, 20 Mo au maximum) dans un conteneur de stockage privé,
              accessibles uniquement par des adresses signées valables une heure</li>
          <li>les annonces par établissement : messages rédigés par les responsables ou les administrateurs
              et lisibles par tous les collaborateurs de l'établissement</li>
        </ul>
        <p>La messagerie sert à la communication interne de l'établissement. Aucune exploitation
        systématique du contenu des communications à des fins de contrôle du comportement ou des
        performances n'a lieu ; elle est interdite à l'employeur en vertu du ch. 19.</p>
      `,
        },
        {
            num: '08',
            title: 'Notifications et Apple Wallet',
            body: `
        <p>Sur les appareils iOS, les modifications de service, les demandes d'échange de service, les corrections de temps et
        les décisions sur les demandes d'absence déclenchent une notification push via l'<strong>Apple Push Notification Service</strong>. À cette
        fin, nous conservons pour chaque appareil un jeton push accompagné d'un identifiant d'appareil ;
        les deux sont supprimés lors de la déconnexion. Les collaborateurs peuvent désactiver les
        notifications dans les paramètres de leur profil et dans les réglages système de l'appareil.
        L'application web n'envoie aucune notification push ; les avis n'y apparaissent qu'au sein de
        l'application ouverte.</p>
        <p>Si l'employeur a activé la notification des heures supplémentaires, les collaborateurs reçoivent
        en début de mois un courriel indiquant leur solde d'heures supplémentaires. L'envoi s'effectue via
        Azure Communication Services (ch. 12).</p>
        <p>Lorsque la fonction Wallet est activée, le backend génère un document <em>.pkpass</em> signé
        servant de badge collaborateur. Il est enregistré localement sur l'appareil ; seul l'état
        d'enregistrement de l'appareil pour les mises à jour automatiques subsiste dans le système.</p>
      `,
        },
        {
            num: '09',
            title: 'Données techniques de connexion et de diagnostic',
            body: `
        <ul>
          <li>données de connexion en temps réel via <strong>Azure SignalR Service</strong> pour les mises
              à jour en direct</li>
          <li>métadonnées des requêtes (adresse IP, adresse appelée, horodatage, code de statut) et
              journaux d'erreurs, traités par <strong>Azure Application Insights</strong> à des fins
              d'exploitation, de diagnostic et de sécurité</li>
        </ul>
        <p>Ce traitement a lieu sur l'infrastructure Azure dans l'UE. Nous sommes nous-mêmes responsables
        de ces données (ch. 01).</p>
      `,
        },
        {
            num: '10',
            title: 'Finalités et bases légales',
            body: `
        <ul>
          <li><strong>Exécution du contrat</strong> (art. 31 al. 2 let. a LPD / art. 6 par. 1 let. b RGPD) :
              fourniture de la prestation de saisie du temps et de gestion du personnel à l'employeur et
              exécution du contrat de travail.</li>
          <li><strong>Obligation légale</strong> (art. 6 par. 1 let. c RGPD) : respect des obligations
              d'enregistrement et de conservation du droit du travail selon l'art. 46 LTr, l'art. 73 OLT 1
              ainsi que des obligations comptables selon le CO.</li>
          <li><strong>Intérêts légitimes</strong> (art. 31 al. 1 LPD / art. 6 par. 1 let. f RGPD) :
              exploitation, sécurité et prévention des abus de la plateforme, y compris les données
              techniques de diagnostic (ch. 09).</li>
          <li><strong>Consentement</strong> (art. 6 al. 6 LPD / art. 6 par. 1 let. a RGPD) : fonctions
              purement facultatives telles que la photo de profil, les notifications push et Apple Wallet,
              que les collaborateurs activent eux-mêmes. Dans une relation de travail, un consentement
              n'est valable que s'il est donné librement ; son refus n'entraîne aucun désavantage pour les
              collaborateurs et il peut être révoqué en tout temps.</li>
        </ul>
      `,
        },
        {
            num: '11',
            title: 'Conservation et effacement',
            body: `
        <p>Les données sont hébergées exclusivement sur l'infrastructure <strong>Microsoft Azure</strong>
        dans l'UE (principalement Europe de l'Ouest).</p>
        <ul>
          <li><strong>Données de temps et de service :</strong> au moins 5 ans après la fin de leur validité
              (art. 73 al. 2 OLT 1) ; ensuite effacées ou anonymisées sur instruction de l'employeur ou à
              la fin du contrat. Un effacement automatique à l'expiration du délai n'est actuellement pas
              mis en place.</li>
          <li><strong>Journal des modifications (ch. 03) :</strong> classé par catégorie de conservation
              (données de session 90 jours, données d'exploitation 2 ans, données juridiquement pertinentes
              10 ans). Un effacement automatique n'est actuellement pas mis en place.</li>
          <li><strong>Pièces à portée comptable :</strong> 10 ans (art. 958f CO).</li>
          <li><strong>Données du personnel :</strong> jusqu'à la fin des rapports de travail, puis
              uniquement aussi longtemps qu'une obligation légale ou une prétention exécutoire l'exige.</li>
          <li><strong>Messages et annonces :</strong> jusqu'à leur suppression par les personnes autorisées
              ou jusqu'à l'anonymisation du compte correspondant.</li>
          <li><strong>Données techniques de diagnostic (ch. 09) :</strong> selon la durée de conservation
              standard d'Azure Application Insights, en règle générale jusqu'à 90 jours.</li>
        </ul>
        <p>L'employeur peut prescrire des délais plus courts pour les données dont il est responsable. À la
        fin du contrat client, nous effaçons ou restituons les données selon ses instructions.</p>
      `,
        },
        {
            num: '12',
            title: 'Destinataires et sous-traitants',
            body: `
        <p>Les données ne sont transmises qu'à des sous-traitants contractuellement tenus de respecter la
        protection des données :</p>
        <ul>
          <li><strong>Okta, Inc. (Auth0)</strong> — authentification, locataire européen avec conservation
              des données dans l'UE ; société mère américaine, couverte par les clauses contractuelles
              types (ch. 02, 13)</li>
          <li><strong>Microsoft Ireland Operations Limited (Azure)</strong> — infrastructure cloud, base de
              données et stockage, SignalR, Application Insights, envoi de courriels transactionnels
              (Azure Communication Services, en particulier les invitations aux collaborateurs) et, si
              activé, IoT Hub pour les terminaux de badge ; centres de données dans l'UE, principalement
              Europe de l'Ouest</li>
          <li><strong>Apple Inc.</strong> — distribution des notifications push et, lorsque la fonction
              Wallet est activée, mise à disposition du badge sur l'appareil</li>
          <li><strong>Cloudflare, Inc.</strong> — résolution de noms (DNS) ainsi que transmission et protection du trafic
              vers chroniq.ch ; les données de requête (notamment l'adresse IP) transitent par le réseau mondial de
              Cloudflare, y compris hors de l'UE ; couvert par des clauses contractuelles types (ch. 13)</li>
        </ul>
        <p>Aucune transmission à d'autres tiers, aucune utilisation à des fins publicitaires, aucune vente
        de données personnelles et aucune utilisation pour l'entraînement de modèles d'IA n'ont lieu. Une
        liste complète des sous-traitants ultérieurs est disponible sur demande ; les nouveaux
        sous-traitants sont annoncés aux clients au préalable.</p>
      `,
        },
        {
            num: '13',
            title: 'Traitement à l\'étranger',
            body: `
        <p>Les données sont hébergées dans l'UE. Certains fournisseurs sont des sociétés américaines
        soumises au droit des États-Unis ; un accès depuis les États-Unis dans le cadre du support et de la
        maintenance ne peut être entièrement exclu.</p>
        <p>De tels transferts reposent sur les <strong>clauses contractuelles types</strong> de la
        Commission européenne (art. 46 par. 2 let. c RGPD) en relation avec l'art. 16 al. 2 let. d LPD, y
        compris les adaptations requises pour la Suisse, complétées par la décision d'adéquation relative
        au <strong>EU–U.S. Data Privacy Framework</strong> et la reconnaissance suisse du
        <strong>Swiss–U.S. Data Privacy Framework</strong>, pour autant que le fournisseur soit certifié.
        Nous maintenons sciemment les clauses contractuelles types comme base autonome, afin que le
        transfert reste couvert même en cas de disparition de la décision d'adéquation.</p>
        <p>Une copie des garanties est disponible sur demande :
        <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a></p>
      `,
        },
        {
            num: '14',
            title: 'Sécurité des données',
            body: `
        <ul>
          <li>Toutes les transmissions sont chiffrées via TLS/HTTPS ; les données au repos sont chiffrées.</li>
          <li>Les accès sont gérés par rôles ; les champs sensibles ne sont visibles que pour les rôles
              autorisés, avec une protection supplémentaire par filtrage des lignes propre au locataire
              dans la base de données.</li>
          <li>Les pièces jointes et les photos de profil se trouvent dans des conteneurs de stockage privés
              sans accès anonyme et ne sont délivrées que par des adresses signées à durée limitée.</li>
          <li>L'authentification s'effectue exclusivement via Auth0 avec OAuth 2.0 / OIDC.</li>
          <li>Dans le portail web, les jetons de connexion sont conservés dans le stockage local du
              navigateur jusqu'à la déconnexion (techniquement nécessaire pour que la session survive à un
              rechargement) ; sur les appareils iOS natifs, les valeurs critiques sont stockées dans le
              trousseau du système d'exploitation.</li>
        </ul>
        <p>Nous annonçons les violations de la sécurité des données au PFPDT dans les meilleurs délais
        (art. 24 LPD). Étant sous-traitante pour les données des collaborateurs, nous informons en outre
        sans délai l'employeur concerné afin qu'il puisse remplir ses propres obligations d'annonce — dans
        les 72 heures selon l'art. 33 RGPD.</p>
      `,
        },
        {
            num: '15',
            title: 'Cookies et stockage local',
            body: `
        <p>Le site web et l'application n'utilisent aucun cookie de marketing ou d'analyse de tiers. Seuls
        des stockages locaux techniquement nécessaires sont employés :</p>
        <ul>
          <li>la préférence d'affichage (mode clair ou sombre)</li>
          <li>dans le portail web, les jetons de connexion (jusqu'à la déconnexion) ainsi que, pour les
              administrateurs, l'établissement sélectionné, afin que la session survive à un rechargement</li>
          <li>la mise en cache des saisies de temps en cours ainsi qu'une file d'attente pour les
              enregistrements effectués sans connexion réseau, synchronisée automatiquement lors du
              rétablissement de la connexion</li>
        </ul>
        <p>Aucun consentement n'est requis pour ces accès techniquement nécessaires.</p>
      `,
        },
        {
            num: '16',
            title: 'Vos droits',
            body: `
        <p>En tant que personne concernée, vous disposez du droit d'accès, de rectification, d'effacement,
        de limitation du traitement, de remise ou de portabilité des données ainsi que du droit d'opposition
        à un traitement fondé sur un intérêt légitime (art. 25 ss LPD / art. 15 ss RGPD). Vous pouvez
        révoquer en tout temps un consentement donné, avec effet pour l'avenir.</p>
        <p>Comme nous agissons pour les données du personnel en qualité de sous-traitante de l'employeur,
        nous transmettons les demandes relatives à ces données à l'employeur compétent ou les traitons sur
        son mandat. <strong>Veuillez adresser de telles demandes d'abord à votre employeur.</strong></p>
        <p>Une demande d'effacement est mise en œuvre techniquement par l'<strong>anonymisation</strong> du
        compte collaborateur : le nom, les coordonnées, les données bancaires et les autres données
        sensibles sont supprimés de manière irréversible du dossier du personnel. Nous supprimons
        séparément, sur instruction de l'employeur, la photo de profil, les enregistrements push et le
        compte de connexion auprès du service d'authentification. Les données de temps, de service et d'audit subsistent sous forme
        anonymisée pour des motifs légaux de conservation (art. 46 LTr, art. 73 OLT 1, CO). Les messages
        déjà envoyés restent visibles sous le nom valable au moment de l'envoi, celui-ci étant conservé de
        manière historique dans le message.</p>
        <p>Contact : <a href="mailto:datenschutz@chroniq.ch">datenschutz&#64;chroniq.ch</a></p>
        <p>Vous pouvez en outre déposer une réclamation auprès du <strong>Préposé fédéral à la protection
        des données et à la transparence (PFPDT)</strong>, Feldeggweg 1, 3003 Berne :
        <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer">www.edoeb.admin.ch</a>.
        Lorsque le traitement relève du RGPD, vous avez également le droit de saisir l'autorité de contrôle
        de votre lieu de résidence ou de travail (art. 77 RGPD).</p>
      `,
        },
        {
            num: '17',
            title: 'Clients internationaux et droit applicable',
            body: `
        <p>Chroniq est utilisé en Suisse et à l'international. Nous appliquons un régime échelonné :</p>
        <ul>
          <li><strong>Suisse :</strong> la LPD s'applique en tant que droit de notre État de siège.</li>
          <li><strong>UE/EEE :</strong> le RGPD s'applique aux personnes concernées dans l'UE/EEE dans la
              mesure où nous fournissons des prestations à des entreprises qui y sont établies ou
              observons le comportement de personnes dans l'UE/EEE (art. 3 par. 2 RGPD). La Suisse
              bénéficie d'une décision d'adéquation de l'UE ; les transferts entre l'UE/EEE et notre
              infrastructure suisse ne nécessitent donc aucune garantie supplémentaire. Dans la mesure où
              l'art. 27 RGPD l'exige, nous désignons un représentant dans l'UE ; ses coordonnées seront
              ajoutées ici dès sa désignation.</li>
          <li><strong>Royaume-Uni :</strong> le UK GDPR s'applique par analogie.</li>
          <li><strong>Autres pays :</strong> nous respectons les prescriptions locales applicables dans la
              mesure où elles ont une incidence sur notre prestation ; des avenants spécifiques par pays
              sont disponibles sur demande.</li>
        </ul>
      `,
        },
        {
            num: '18',
            title: 'Intelligence artificielle',
            body: `
        <p>Chroniq n'utilise <strong>aucun</strong> système d'intelligence artificielle au sens du
        règlement (UE) 2024/1689 (« règlement sur l'IA »). La planification des services, le calcul des
        heures supplémentaires, le compte de vacances et le traitement des demandes d'absence reposent
        exclusivement sur une logique programmée fondée sur des règles.</p>
        <p>Le règlement sur l'IA est généralement applicable depuis le 2 août 2026. Il est particulièrement
        strict dans le domaine des ressources humaines : les systèmes d'IA qui attribuent des tâches liées
        au travail sur la base du comportement individuel ou de caractéristiques personnelles, ou qui
        surveillent et évaluent la performance et le comportement des collaborateurs, sont considérés comme
        des <strong>systèmes à haut risque</strong> selon l'annexe III ch. 4. La reconnaissance des
        émotions sur le lieu de travail est <strong>interdite</strong> par l'art. 5 par. 1 let. f depuis le
        2 février 2025. Chroniq ne comporte aucune fonction de ce type.</p>
        <p>Si une composante d'IA devait être introduite à l'avenir — par exemple dans le cadre d'une
        fonction d'analyse ou de prévision —, nous procéderions au préalable à sa classification selon le
        règlement sur l'IA et mettrions à jour la présente déclaration avant sa mise en service. Pour un
        système à haut risque, l'employeur devrait en outre, en tant que déployeur, remplir les obligations
        de l'art. 26, en particulier informer la représentation des travailleurs et les collaborateurs
        concernés avant la mise en service (art. 26 par. 7).</p>
      `,
        },
        {
            num: '19',
            title: 'Pas de contrôle du comportement, pas de décision automatisée',
            body: `
        <p>Chroniq ne prend aucune décision fondée exclusivement sur un traitement automatisé, y compris le
        profilage, produisant des effets juridiques à l'égard des collaborateurs ou les affectant de manière
        significative de façon analogue (art. 21 LPD / art. 22 RGPD). Les demandes d'absence, l'attribution
        des services, les avertissements et la fin des rapports de travail sont toujours décidés par un
        être humain.</p>
        <p>Selon l'art. 26 al. 1 de l'ordonnance 3 relative à la loi sur le travail, les systèmes de
        surveillance ou de contrôle destinés à surveiller le comportement des travailleurs à leur poste de
        travail <strong>ne peuvent pas</strong> être utilisés. Chroniq est destiné à l'enregistrement du
        temps de travail et à l'organisation des engagements, non à une surveillance du comportement.
        L'employeur s'engage contractuellement à ne pas utiliser les fonctions d'analyse à des fins de
        contrôle permanent du comportement ou des performances.</p>
      `,
        },
        {
            num: '20',
            title: 'Personnes mineures',
            body: `
        <p>Chroniq s'adresse aux collaborateurs dans le cadre de rapports de travail. L'employeur est
        responsable de l'utilisation par des collaborateurs mineurs, par exemple des apprentis ; le
        consentement du représentant légal peut être nécessaire. Les dispositions particulières de
        protection des jeunes travailleurs selon les art. 29 ss LTr et l'ordonnance sur la protection des
        jeunes travailleurs demeurent réservées et doivent être respectées par l'employeur.</p>
      `,
        },
        {
            num: '21',
            title: 'Modifications de la présente déclaration',
            body: `
        <p>Nous réexaminons régulièrement la présente déclaration et l'adaptons lorsque la situation
        juridique ou nos traitements évoluent. La version en vigueur est disponible à l'adresse
        <a href="https://www.gastro-management.ch/datenschutz?lang=fr#chroniq">gastro-management.ch/datenschutz</a>.
        Nous informons les utilisateurs enregistrés des modifications importantes par courriel. La date de
        la dernière révision figure en tête de page.</p>
      `,
        },
    ],
};
